import { CardPrinterPage } from "@features/card-printer/components/CardPrinterPage";
import { meSessionQueryOptions } from "@features/me/queries";
import { normalizePermission } from "@features/rbac/permissions";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/assets/card-printer")({
    beforeLoad: async ({ context }) => {
        const session = await context.queryClient.ensureQueryData(meSessionQueryOptions());
        if (session.viewMode !== "staff" || !session.permissions.some(permission => normalizePermission(permission) === "card-printers.manage")) {
            throw redirect({ to: "/home" });
        }
    },
    component: CardPrinterPage,
    staticData: { crumb: { label: "Card printer" } },
});
